// Federal-fiscal-year quarter derivation for the QASP tab (SAD-174).
//
// The stored/extracted quarter label is `YYYY-Qn`, where YYYY is the FISCAL
// year (matches qasp_extractor.go and the fixture omega/qasp/qasp-q2-fy2026 —
// see QASPScoresTab.tsx's field-binding comment). Federal fiscal quarters:
//   FY{Y} Q1 = {Y-1}-10-01 .. {Y-1}-12-31
//   FY{Y} Q2 = {Y}-01-01   .. {Y}-03-31
//   FY{Y} Q3 = {Y}-04-01   .. {Y}-06-30
//   FY{Y} Q4 = {Y}-07-01   .. {Y}-09-30
//
// Every boundary is a fixed month/day (never Feb 29), so every date here is
// built by plain string composition ("${year}-10-01") rather than `Date`
// arithmetic: composition is exact, needs no timezone reasoning, and cannot
// drift a day the way constructing/reformatting a `Date` object can. The
// composed YYYY-MM-DD strings are exactly what parseLocalDate (nullable.ts)
// already expects for every delivery calendar field.
/** FY + quarter -> { start, end } as YYYY-MM-DD strings, by string composition only. */ export function fiscalQuarterDates(fiscalYear, quarter) {
    switch(quarter){
        case 1:
            return {
                start: `${fiscalYear - 1}-10-01`,
                end: `${fiscalYear - 1}-12-31`
            };
        case 2:
            return {
                start: `${fiscalYear}-01-01`,
                end: `${fiscalYear}-03-31`
            };
        case 3:
            return {
                start: `${fiscalYear}-04-01`,
                end: `${fiscalYear}-06-30`
            };
        case 4:
            return {
                start: `${fiscalYear}-07-01`,
                end: `${fiscalYear}-09-30`
            };
    }
}
/** Composes the persisted label — the picker writes exactly this format. */ export function fiscalQuarterLabel(fiscalYear, quarter) {
    return `${fiscalYear}-Q${quarter}`;
}
const LABEL_RE = /^(\d{4})-Q([1-4])$/;
/**
 * Parses a stored/extracted quarter label back to { fiscalYear, quarter }.
 * Returns the literal string 'unparseable' for anything that isn't exactly
 * `YYYY-Qn` (n in 1-4) — never a wrong guess, never NaN — so a legacy
 * free-text quarter is recognized as such and left for the caller to render
 * and persist unchanged rather than coerced.
 */ export function parseFiscalQuarterLabel(label) {
    const match = LABEL_RE.exec(label);
    if (!match) return 'unparseable';
    return {
        fiscalYear: Number(match[1]),
        quarter: Number(match[2])
    };
}
